"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("./styles.scss");
var _util = require("./util");
var Form = _interopRequireWildcard(require("./components/form"));
var _results = require("./components/results");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var noop = function noop() {};
var BLOCK_CLASS = 'pf-provider-search';
var ProviderSearch = function ProviderSearch(_ref) {
  var onSearch = _ref.onSearch,
    onCancel = _ref.onCancel,
    onSelect = _ref.onSelect,
    hasError = _ref.hasError;
  var _useState = (0, _react.useState)(0),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    total = _useState2[0],
    setTotal = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    results = _useState4[0],
    setResults = _useState4[1];
  var bem = (0, _util.klass)(BLOCK_CLASS);
  var search = function search(data) {
    return onSearch(data).then(function (res) {
      setTotal(res.totalResults);
      setResults(res.results);
    });
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: BLOCK_CLASS
  }, /*#__PURE__*/_react.default.createElement(Form.Search, {
    onSubmit: search,
    onCancelClick: onCancel
  }), /*#__PURE__*/_react.default.createElement(_results.Result, {
    total: total,
    results: results,
    onSelect: onSelect
  }), hasError && /*#__PURE__*/_react.default.createElement("p", {
    className: bem('error')
  }, "Sorry! We are unable to process your request at this time. Please try again later."));
};
ProviderSearch.propTypes = {
  /**
   * Accepts { location, name } object
   * Returns { total, results } object
   */
  onSearch: _propTypes.default.func.isRequired,
  /**
   * Accepts (e, item), where e: React event, item: entire item element
   */
  onSelect: _propTypes.default.func.isRequired,
  onCancel: _propTypes.default.func,
  hasError: _propTypes.default.bool
};
ProviderSearch.defaultProps = {
  onCancel: noop,
  hasError: false
};
var _default = exports.default = ProviderSearch;
